import React from "react";
import vector1 from "../../assets/Vector (1).svg";
import usePageContent from "../../hooks/usePageContent";

const serif = "'Playfair Display', Georgia, serif";
const sans = "'Poppins', 'Segoe UI', sans-serif";

/* ✏️ All copy editable here */
const CARDS = [
  { title: "24K Gold Infusion", body: ["Enhances skin radiance for a luminous,", "youthful-looking complexion."] },
  { title: "Collagen Complex", body: ["Supports skin firmness and improves", "elasticity over time."] },
  { title: "Hyaluronic Moisture Lock", body: ["Provides deep hydration for soft, smooth, and", "plump-looking skin."] },
  { title: "Vitamin C Brightening", body: ["Brightens dull skin and promotes a naturally", "even complexion."] },
  { title: "Botanical Recovery Blend", body: ["Nourishes and calms skin with carefully", "selected botanical extracts."] },
  { title: "Peptide Firming Technology", body: ["Helps improve skin firmness for a smoother,", "youthful appearance."] },
];

const FormulaSpotlight = () => {
  const content = usePageContent('royal-luxury');
  const fields = content?.fields || {};

  // Each card's title can be overridden (formulaCard1Title, …); the
  // two-line body stays as designed since it's tied to the layout.
  const cards = CARDS.map((c, i) => ({ ...c, title: fields[`formulaCard${i + 1}Title`] || c.title }));

  return (
  <section id="shine-formula" className="fs-sec">
    <style>{`
      /* ============ DESKTOP ≥1024 — ORIGINAL CODE, VERBATIM ============ */
      .fs-sec{position:relative;width:100%;height:40.3125vw;background:#fff;overflow:hidden;}

      /* ---- header ---- */
      .fs-tag{
      position:absolute;
      top:3.8vw;
      width:100%;
      text-align:center;
      color:#E38F2E;     
      font-family:${sans};
      font-size:0.85vw;
      font-weight:600;
      letter-spacing:0.18em;
      text-transform:uppercase;
      }
      
      .fs-title{
      position:absolute;
      top:5vw;
      width:100%;
      text-align:center;
      color:#2E3192;
      font-family:${serif};
      font-size:1.65vw;
      font-weight:600;
      line-height:normal;
      text-transform:capitalize;
      }
      
      .fs-vector{
      position:absolute;
      top:7.2917vw;
      left:50%;
      transform:translateX(-50%);
      width:9.4583vw;
      height:auto;
      }
      
      /* ✅ CENTERED: left+right pinned so the auto margins truly center the
         capped 60vw box (also removed the stray "s" typo) */
      .fs-sub{
      position:absolute;
      top:8.9063vw;
      left:0;
      right:0;
      width:auto;
      max-width:60vw;
      margin:0 auto;
      text-align:center;
      color:#666666;
       font-family:${sans};
       font-size:0.93vw;
       letter-spacing: 0.045em;
       line-height:1.5625vw;
       }

      .fs-grid{position:absolute;left:8.8542vw;top:14.375vw;width:82.2917vw;
        display:grid;grid-template-columns:repeat(3, 26.0417vw);gap:2.0833vw;}

      .fs-card{
      background:#FCF9F2;
      border:0.0521vw solid #D7DAE4;
      border-radius:0.5208vw;
      height:9.375vw;
      padding:2.0833vw 1.5625vw;
      box-shadow:0 0.4167vw 0.8333vw rgba(0,0,0,0.10),
                 0 1.0417vw 2.0833vw rgba(43,46,126,0.08);
      cursor:pointer;
      transition:border-color .3s ease, box-shadow .3s ease;
      }

      .fs-card:hover{
      border-color:#CCA466;
      box-shadow:0 0.625vw 1.25vw rgba(0,0,0,0.12),
                 0 1.5625vw 3.125vw rgba(43,46,126,0.20);
      }
      
      .fs-card h3{
      color:#2E3192;
      font-family:${serif};
      font-size:1.0417vw;
      font-style: normal;
      font-weight:600;
      letter-spacing: 0.025em;
      line-height: normal;
      }
      .fs-rule{width:2.6042vw;height:0.1563vw;background:#CCA466;margin-top:0.625vw;border-radius:0.0781vw;}
      .fs-card p{margin-top:0.8333vw;color:#666666;font-family:${sans};
        font-size:0.8333vw;line-height:1.4063vw;}

      /* ============ MOBILE+TABLET ≤1023 — ONE CARD PER ROW, no columns ============ */
      @media (max-width:1023px){
        .fs-sec{height:auto;padding:10vw 5vw;}

        .fs-tag{position:static;font-size:clamp(12px, 1.4vw, 18px);}
        .fs-title{position:static;font-size:clamp(20px, 2.3vw, 32px);margin-top:0vw;}
        .fs-vector{position:static;transform:none;display:block;
          width:clamp(70px, 12vw, 120px);margin:2.5vw auto 0;}

        /* ✅ centered capped box on small screens; br visible everywhere */
        .fs-sub{position:static;font-size:clamp(12px, 1.35vw, 17px);
          line-height:clamp(18px, 2vw, 26px);
          max-width:720px;margin:1vw auto 0;text-align:center;}

        .fs-grid{position:static;left:auto;top:auto;width:auto;
          grid-template-columns:1fr;gap:4vw;margin-top:8vw;}

        .fs-card{height:auto;padding:5vw;border-radius:2vw;
          box-shadow:0 2px 6px rgba(0,0,0,0.08),
                     0 6px 16px rgba(43,46,126,0.08);}
        .fs-card:hover{box-shadow:0 4px 10px rgba(0,0,0,0.10),
                                  0 12px 24px rgba(43,46,126,0.18);}
        .fs-card h3{font-size:clamp(14px, 1.7vw, 21px);}
        .fs-rule{width:clamp(36px, 7vw, 50px);height:3px;margin-top:2vw;border-radius:2px;}
        .fs-card p{margin-top:2.5vw;font-size:clamp(11px, 1.25vw, 15px);
          line-height:clamp(16px, 1.8vw, 22px);}
        .fs-card p br{display:none;}
      }

      /* ============ TABLET 640–1023 — ✅ 2 CARDS PER ROW ============ */
      @media (min-width:640px) and (max-width:1023px){
        .fs-sec{padding:8vw 6vw;}
        .fs-tag{font-size:13px;}
        .fs-title{font-size:28px;}

        .fs-vector{width:18%; margin-top:1vw;}

        .fs-sub{font-size:14px;line-height:1.6;}

        .fs-grid{
          grid-template-columns:1fr 1fr;
          gap:24px 20px;
          margin-top:40px;
        }

        .fs-card{padding:24px 22px;border-radius:16px;}
        .fs-card h3{font-size:16px;}
        .fs-rule{width:44px;height:3px;margin-top:10px;border-radius:2px;}
        .fs-card p{font-size:13px;line-height:1.5;margin-top:12px;}
      }
    `}</style>

    <p className="fs-tag">{fields.formulaEyebrow || 'Formula Spotlight'}</p>
    <h2 className="fs-title">{fields.formulaTitle || 'Advanced beauty Science, Perfected'}</h2>
    <img className="fs-vector" src={vector1} alt="" aria-hidden="true" />
    {/* ✅ centered; line breaks right after "science," on all breakpoints */}
    <p className="fs-sub">
      {fields.formulaDescription || 'Every Royal Luxury formula blends premium ingredients, advanced skincare science, and luxurious care.'}
    </p>

    <div className="fs-grid">
      {cards.map((c) => (
        <div className="fs-card" key={c.title}>
          <h3>{c.title}</h3>
          <div className="fs-rule" />
          <p>{c.body[0]}<br />{c.body[1]}</p>
        </div>
      ))}
    </div>
  </section>
  );
};

export default FormulaSpotlight;